import { dataReportUserSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportUserSolid = /*#__PURE__*/createIcon(dataReportUserSolid)
export default IconReportUserSolid
